import _ from "axios";
import * as e from "zod";
import { z as t } from "zod";
import { fromZodError as w } from "zod-validation-error";
import { LocalStorage as A } from "@made-people/local-storage";
const V = {
  debug(...r) {
  }
};
var i = /* @__PURE__ */ ((r) => (r.POST = "post", r.GET = "get", r.PATCH = "patch", r.PUT = "put", r.DELETE = "delete", r))(i || {});
class Q {
  constructor(n) {
    this.options = n, this.logger = this.options.logger || V, this.client = this.getAxiosClient();
  }
  getAxiosClient() {
    let n = {};
    if (this.options.centraTokenHandler) {
      const s = this.options.centraTokenHandler.getToken();
      n = s ? {
        "API-Token": s
      } : {};
    }
    const o = _.create({
      baseURL: this.options.baseUrl,
      timeout: this.options.transport.timeout,
      headers: n
    });
    return o.interceptors.request.use((s) => (this.options.centraTokenHandler && (s.headers["API-Token"] = this.options.centraTokenHandler.getToken()), s)), o.interceptors.response.use((s) => {
      var u;
      return this.options.centraTokenHandler && ((u = s == null ? void 0 : s.data) != null && u.token) && this.options.centraTokenHandler.setToken(s.data.token), s;
    }), o;
  }
  async request(n) {
    var s;
    const o = {
      ...n,
      validateStatus: () => !0
    };
    return (s = this.logger) == null || s.debug(`Making request ${JSON.stringify(o)}`), await this.client.request(o).then((u) => u);
  }
}
function G(r) {
  return new Q({ ...K(), ...r });
}
function K() {
  return {
    transport: {
      timeout: 6e4
    }
  };
}
const j = t.object({
  key: t.string(),
  consented: t.boolean(),
  name: t.string().optional(),
  text: t.string().optional(),
  version: t.string().optional(),
  language: t.string().optional()
}), J = t.object({
  email: t.string(),
  password: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  address1: t.string().optional(),
  address2: t.string().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  state: t.string().optional(),
  country: t.string().optional(),
  phoneNumber: t.string().optional(),
  newsletter: t.boolean().optional(),
  language: t.string().optional(),
  consents: t.array(j).optional()
}), q = t.object({
  address1: t.string(),
  address2: t.string(),
  city: t.string(),
  consents: t.array(
    t.object({
      key: t.string(),
      consented: t.boolean()
    })
  ).optional(),
  country: t.string(),
  email: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  phoneNumber: t.string(),
  state: t.string(),
  zipCode: t.string(),
  // Do these actually exist in the response?
  gender: t.string().optional(),
  language: t.string().optional().nullable(),
  newsletter: t.boolean().optional()
}), k = q.extend({
  customer: t.string()
}), h = t.object({
  language: t.string(),
  name: t.string(),
  default: t.boolean()
}), y = t.object({
  country: t.string(),
  name: t.string(),
  eu: t.boolean(),
  language: t.string(),
  currency: t.string(),
  states: t.array(
    t.object({
      state: t.string(),
      name: t.string()
    })
  ).optional()
}), S = t.object({
  country: t.string(),
  name: t.string(),
  state: t.union([t.string(), t.null()]),
  stateName: t.string(),
  eu: t.boolean(),
  shipTo: t.boolean(),
  language: h,
  market: t.number(),
  pricelist: t.number()
}), f = t.object({
  email: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  company: t.string(),
  address1: t.string(),
  address2: t.string(),
  zipCode: t.string(),
  city: t.string(),
  country: t.string(),
  phoneNumber: t.string(),
  state: t.string().optional(),
  vatNumber: t.string().optional()
}), X = t.object({
  category: t.string(),
  name: t.array(t.string()),
  sortOrder: t.number(),
  uri: t.string(),
  attributes: t.union([t.array(t.unknown()), t.record(t.string(), t.unknown())]).optional(),
  pathIds: t.array(t.string()).optional()
}), Y = t.object({
  media: t.number(),
  sources: t.any(),
  attributes: t.any(),
  altText: t.string().optional()
}), Z = t.object({
  periodDays: t.number(),
  price: t.string(),
  priceAsNumber: t.number(),
  priceBeforeDiscount: t.string(),
  priceBeforeDiscountAsNumber: t.number()
}), tt = t.object({
  warehouse: t.number().optional(),
  stock: t.number().optional()
}), et = t.object({
  sizeId: t.string(),
  item: t.string(),
  ean: t.string(),
  itemTableX: t.number(),
  itemTableY: t.number(),
  name: t.string(),
  upc: t.string().optional(),
  sku: t.string(),
  stock: t.string().or(t.number()).optional(),
  // This can be a string (Yes/No) or a number (Stock in quantity), depending on settings in Centra Checkout API
  // Optional per-warehouse stock quantities. Not always present: the Centra
  // Checkout API only returns this when a shared secret is configured, and some
  // clients instead populate it via an adapter from Shop API product data.
  warehouses: t.array(tt).optional()
}), nt = t.object({
  priceType: t.string(),
  type: t.string(),
  priceOfItems: t.string(),
  priceMin: t.string(),
  priceMax: t.string(),
  priceOfItemsAsNumber: t.number(),
  priceMinAsNumber: t.number(),
  priceMaxAsNumber: t.number(),
  priceMinBeforeDiscountAsNumber: t.number(),
  priceMaxBeforeDiscountAsNumber: t.number(),
  priceMinBeforeDiscount: t.string(),
  priceMaxBeforeDiscount: t.string(),
  discount: t.number()
}), rt = t.object({
  unit: t.string(),
  x: t.union([t.record(t.string()), t.array(t.string())]),
  y: t.union([t.record(t.string()), t.array(t.string())]),
  dividerSymbol: t.string()
}), x = t.object({
  product: t.string(),
  name: t.string(),
  uri: t.string(),
  sku: t.string(),
  productSku: t.string(),
  brand: t.string(),
  brandName: t.string().nullable(),
  brandUri: t.string().nullable(),
  collection: t.string().optional().nullable(),
  collectionName: t.string().optional().nullable(),
  collectionUri: t.string().optional().nullable(),
  variantName: t.string(),
  countryOrigin: t.string().optional().nullable(),
  excerpt: t.string(),
  excerptHtml: t.string(),
  description: t.string(),
  descriptionHtml: t.string(),
  metaTitle: t.string(),
  metaDescription: t.string(),
  metaKeywords: t.string(),
  stockUnit: t.string(),
  category: t.string().nullable(),
  categoryName: t.array(t.string()).nullable(),
  createdAt: t.string(),
  modifiedAt: t.string(),
  categoryUri: t.string().nullable(),
  centraProduct: t.string(),
  centraVariant: t.string(),
  itemQuantityMinimum: t.number(),
  itemQuantityMultipleOf: t.number(),
  price: t.string(),
  priceAsNumber: t.number(),
  priceBeforeDiscount: t.string(),
  priceBeforeDiscountAsNumber: t.number(),
  discountPercent: t.number(),
  lowestPrice: t.array(Z),
  showAsOnSale: t.boolean(),
  showAsNew: t.boolean(),
  available: t.boolean().optional(),
  bundleInfo: nt.optional(),
  tableMappings: t.record(t.string(), rt).optional(),
  itemTable: t.object({
    unit: t.string(),
    original: t.object({
      x: t.array(t.string()).optional(),
      y: t.array(t.string()).optional()
    }),
    desc: t.string().optional(),
    x: t.array(t.string()),
    y: t.array(t.string()),
    dividerSymbol: t.string()
  }),
  items: t.array(et),
  categories: t.array(X).optional(),
  media: t.any(),
  mediaObjects: t.array(Y),
  mediaUrls: t.array(t.string()).optional(),
  relation: t.string().optional(),
  subscriptionPlans: t.array(t.any()).optional()
}).passthrough(), ot = x.extend({
  relation: t.string()
}), b = x.extend({
  relatedProducts: t.array(ot).optional()
}), st = e.object({
  bundle: e.number(),
  type: e.enum(["fixed", "flexible"]),
  priceType: e.enum(["static", "dynamic"]),
  priceOfItems: e.string(),
  priceOfItemsAsNumber: e.number(),
  minPrice: e.string(),
  minPriceAsNumber: e.number(),
  maxPrice: e.string(),
  maxPriceAsNumber: e.number()
}), it = e.object({
  bundleInfo: st,
  sections: e.array(
    e.object({
      section: e.string(),
      quantity: e.number(),
      products: e.array(e.number())
    })
  )
}), at = e.object({
  anyDiscount: e.boolean(),
  brandName: e.string(),
  category: e.string().optional().nullable(),
  comment: e.string().nullable(),
  discounts: e.any().nullable(),
  ean: e.string(),
  item: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  product: e.string(),
  productName: e.string(),
  productUri: e.string().optional().nullable(),
  quantity: e.number(),
  silkProduct: e.string(),
  silkVariant: e.string(),
  size: e.string(),
  sku: e.string(),
  taxPercent: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number()
}), ct = e.object({
  item: e.string(),
  productUrl: e.union([e.string(), e.null()]),
  category: e.string(),
  size: e.string(),
  sku: e.string(),
  ean: e.string(),
  quantity: e.number(),
  comment: e.string(),
  line: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  anyDiscount: e.boolean(),
  taxPercent: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number(),
  totalPriceAfterDiscount: e.string(),
  totalPriceAfterDiscountAsNumber: e.number(),
  product: b,
  bundle: it,
  subscriptionPlan: e.any()
}), E = e.object({
  item: e.string(),
  productUrl: e.union([e.string(), e.null()]),
  category: e.union([e.string(), e.null()]).nullable(),
  campaign: e.object({
    discount: e.string(),
    discountAsNumber: e.number(),
    name: e.string()
  }).optional(),
  size: e.string(),
  sku: e.string(),
  ean: e.string(),
  quantity: e.number(),
  comment: e.union([e.string(), e.null()]).nullable(),
  line: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  totalPriceAfterDiscount: e.string(),
  totalPriceAfterDiscountAsNumber: e.number(),
  anyDiscount: e.boolean(),
  taxPercent: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number(),
  product: b,
  bundle: e.array(at).optional(),
  bundleReference: e.string().optional(),
  subscriptionPlan: e.any()
}), R = e.object({
  currency: e.string(),
  name: e.string(),
  prefix: e.string(),
  suffix: e.string(),
  decimalPoint: e.string(),
  decimalDigits: e.string(),
  thousandsSeparator: e.string(),
  uri: e.string()
}), lt = e.union([
  E,
  ct
]), M = e.object({
  // Seems to always be '2', but since we don't know what this number means we can't turn it into
  // a literal without breaking checkout.
  version: e.number(),
  snippet: e.string().optional(),
  session_id: e.string().optional(),
  ingridAttributes: e.any(),
  deliveryOptionsAvailable: e.boolean()
}), ut = e.object({
  paymentHTML: e.string().optional(),
  klarnaReplaceSnippet: e.boolean().optional(),
  ingrid: M.optional(),
  shipwallet: M.optional()
}), v = e.object({
  voucher: e.string(),
  type: e.enum(["code", "uri", "other"]).optional(),
  description: e.string(),
  priceOff: e.string(),
  hasAffectedOrder: e.boolean(),
  priceOffAsNumber: e.number(),
  attributes: e.union([e.array(e.unknown()), e.record(e.string(), e.unknown())]).nullish()
}), pt = e.object({
  automaticDiscount: e.string().or(e.number()),
  hasAffectedOrder: e.boolean(),
  name: e.string(),
  priceOff: e.string(),
  priceOffAsNumber: e.number(),
  freeShippingFor: e.array(e.string()).optional()
}), B = e.object({
  affiliateHtml: e.string().optional(),
  giftMessage: e.string().optional(),
  language: e.string(),
  currency: e.string(),
  paymentMethod: e.string(),
  paymentMethodName: e.string(),
  shippingMethod: e.string(),
  shippingMethodName: e.string(),
  pluginFields: ut.optional(),
  centraCheckoutScript: e.string().optional().nullable(),
  // Optional but added to the schema when Qliro is selected as payment method
  qliroReplaceSnippet: e.boolean().optional(),
  // Optional but added to the schema an iframe payment method is configured for the selection
  paymentHTML: e.string().optional(),
  items: e.array(lt),
  discounts: e.object({
    anyDiscount: e.boolean(),
    discount: e.string(),
    discountAsNumber: e.number(),
    automaticDiscounts: e.array(pt),
    vouchers: e.array(v)
  }),
  totals: e.object({
    itemsTotalPrice: e.string(),
    itemsTotalPriceAsNumber: e.number(),
    totalDiscountPrice: e.union([e.string(), e.boolean(), e.number()]),
    totalDiscountPriceAsNumber: e.union([e.number(), e.boolean()]),
    shippingPrice: e.string(),
    shippingPriceAsNumber: e.number(),
    handlingCostAddedToShippingPrice: e.boolean().optional(),
    totalQuantity: e.number(),
    taxDeducted: e.union([e.string(), e.boolean()]),
    taxDeductedAsNumber: e.union([e.number(), e.boolean()]),
    taxAdded: e.union([e.string(), e.boolean()]),
    taxAddedAsNumber: e.union([e.number(), e.boolean()]),
    taxPercent: e.number(),
    grandTotalPrice: e.string(),
    grandTotalPriceAsNumber: e.number(),
    grandTotalPriceTax: e.string(),
    grandTotalPriceTaxAsNumber: e.number()
  }),
  vatExempt: e.boolean(),
  additionalNotes: e.string(),
  address: f,
  shippingAddress: f,
  currencyFormat: R.extend({
    denominator: e.number().optional()
  })
}), U = e.object({
  paymentMethod: e.string(),
  name: e.string(),
  clientSide: e.object({
    externalScript: e.string().optional()
  }).optional(),
  handlingCost: e.string(),
  handlingCostAsNumber: e.number(),
  providesCustomerAddressAfterPayment: e.boolean(),
  paymentMethodType: e.string()
}), c = e.object({
  type: e.string(),
  visible: e.boolean(),
  required: e.boolean()
}), F = e.object({
  termsAndConditions: c,
  address: e.object({
    email: c,
    company: c,
    firstName: c,
    lastName: c,
    address1: c,
    address2: c,
    zipCode: c,
    city: c,
    state: c,
    country: c,
    phoneNumber: c,
    identityNumber: c,
    vatNumber: c,
    houseNumber: c,
    houseExtension: c,
    newsletter: c
  }),
  shippingAddress: e.object({
    email: c,
    company: c,
    firstName: c,
    lastName: c,
    address1: c,
    address2: c,
    zipCode: c,
    city: c,
    state: c,
    country: c,
    phoneNumber: c,
    houseNumber: c,
    houseExtension: c
  })
}), $ = e.object({
  shippingMethod: e.string(),
  name: e.string(),
  price: e.string(),
  priceAsNumber: e.number()
}), p = e.object({
  token: e.string(),
  selection: B,
  languages: e.array(h),
  paymentMethods: e.array(U),
  paymentFields: F,
  shippingMethods: e.array($),
  countries: e.array(y),
  loggedIn: k.optional(),
  location: S
});
function a(r, n, o, s) {
  if (r.status >= 200 && r.status <= 299) {
    const u = n.safeParse(r.data);
    if (!u.success)
      throw new Error(
        `[${s}] Error parsing Success Response: ${w(
          u.error
        ).toString()}`
      );
    return { success: u.data, error: null };
  } else {
    const u = o.safeParse(r.data);
    if (!u.success)
      throw new Error(
        `[${s}] Error parsing Error Response: ${w(
          u.error
        ).toString()}`
      );
    return { success: null, error: u.data };
  }
}
const g = t.object({
  token: t.string()
}), mt = e.record(e.string()), l = g.extend({
  errors: mt
});
function m(r, n, o) {
  const s = r.safeParse(n);
  s.success || console.error(
    `[${o}] Error parsing input: ${w(s.error).toString()}`
  );
}
const dt = (r) => async (n) => {
  m(J, n, "register");
  const o = await r.transporter.request({
    url: "/register",
    data: n,
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "register"
  );
};
function P(r) {
  return encodeURIComponent(decodeURIComponent(r));
}
const gt = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: `/login/${P(n)}`,
    data: {
      password: o
    },
    method: i.POST
  });
  return a(
    s,
    p,
    l,
    "login"
  );
}, z = e.object({
  order: e.string(),
  items: E.array(),
  status: e.enum(["untouched", "progress", "ok", "archived", "failed"]).optional(),
  statusDescription: e.enum([
    "Pending",
    "Confirmed",
    "Processing",
    "Completed",
    "Archived",
    "Canceled",
    "Incomplete"
  ]).optional(),
  date: e.string().optional(),
  giftMessage: e.string().optional(),
  shipments: e.array(
    e.object({
      shipmentId: e.string().optional(),
      shippedDate: e.string().optional(),
      carrier: e.string().optional(),
      service: e.string().optional(),
      trackingId: e.string().optional(),
      trackingUrl: e.string().optional(),
      returnSlipTracking: e.string().optional(),
      additionalMessage: e.string().nullable().optional()
    })
  ).optional(),
  language: e.string().nullable().optional(),
  currency: e.string().nullable().optional(),
  paymentMethod: e.string(),
  paymentMethodName: e.string(),
  paymentMethodData: e.object({
    snippet: e.string().optional()
  }).optional(),
  shippingMethod: e.string(),
  shippingMethodName: e.string(),
  pluginFields: e.record(e.any()).optional(),
  centraCheckoutScript: e.string().optional(),
  discounts: e.object({
    anyDiscount: e.boolean().optional(),
    discount: e.string().optional(),
    discountAsNumber: e.number().optional(),
    vouchers: e.array(v).optional()
  }).optional(),
  currencyFormat: R,
  totals: e.object({
    itemsTotalPrice: e.string(),
    itemsTotalPriceAsNumber: e.number(),
    totalDiscountPrice: e.union([e.string(), e.boolean(), e.number()]),
    totalDiscountPriceAsNumber: e.union([e.number(), e.boolean()]),
    shippingPrice: e.string(),
    shippingPriceAsNumber: e.number(),
    handlingCostAddedToShippingPrice: e.boolean().optional(),
    totalQuantity: e.number(),
    taxDeducted: e.union([e.string(), e.boolean()]),
    taxDeductedAsNumber: e.union([e.number(), e.boolean()]),
    taxAdded: e.union([e.string(), e.boolean()]),
    taxAddedAsNumber: e.union([e.number(), e.boolean()]),
    taxPercent: e.number(),
    grandTotalPrice: e.string(),
    grandTotalPriceAsNumber: e.number(),
    grandTotalPriceTax: e.string(),
    grandTotalPriceTaxAsNumber: e.number(),
    totalOriginalDiscountPrice: e.union([e.string(), e.boolean()]),
    totalOriginalDiscountPriceAsNumber: e.union([e.number(), e.boolean()])
  }),
  vatExempt: e.boolean().optional(),
  additionalNotes: e.string().optional(),
  address: e.object({
    email: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional(),
    company: e.string().optional(),
    address1: e.string().optional(),
    address2: e.string().optional(),
    zipCode: e.string().optional(),
    city: e.string().optional(),
    state: e.string().optional(),
    country: e.string().optional(),
    countryName: e.string().optional(),
    phoneNumber: e.string().optional(),
    vatNumber: e.string().optional()
  }).optional(),
  shippingAddress: e.object({
    email: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional(),
    company: e.string().optional(),
    address1: e.string().optional(),
    address2: e.string().optional(),
    zipCode: e.string().optional(),
    city: e.string().optional(),
    state: e.string().optional(),
    country: e.string().optional(),
    countryName: e.string().optional(),
    phoneNumber: e.string().optional()
  }).optional()
}), bt = t.object({
  from: t.number(),
  size: t.number(),
  totalSize: t.number()
}), C = t.object({
  countries: t.array(y),
  languages: t.array(h),
  location: S,
  loggedIn: q,
  orders: t.array(z),
  ordersPaging: bt,
  token: t.string()
}), ht = (r) => async () => {
  const n = await r.transporter.request({
    url: "/orders",
    method: i.POST
  }), o = C.extend({
    orders: e.array(e.any())
  }), s = a(
    n,
    o,
    l,
    "getCustomerOrders"
  );
  if (!s.success)
    return s;
  const u = s.success.orders.map((d) => {
    const T = C.shape.orders.element.safeParse(d);
    return T.success ? T.data : (console.warn("Invalid order format for order:", T.error), null);
  }).filter((d) => d !== null);
  return {
    success: {
      ...s.success,
      orders: u
    },
    error: null
  };
}, yt = (r) => async () => {
  const n = await r.transporter.request({
    url: "/logout",
    method: i.POST
  });
  return a(
    n,
    p,
    l,
    "logout"
  );
}, ft = t.object({
  firstName: t.string(),
  lastName: t.string(),
  newEmail: t.string().optional(),
  address1: t.string().optional(),
  address2: t.string().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  state: t.string().optional(),
  country: t.string().optional(),
  phoneNumber: t.string().optional(),
  newsletter: t.boolean().optional(),
  language: t.string().optional(),
  consents: t.array(j).optional()
}), St = (r) => async (n) => {
  m(ft, n, "updateCustomerInfo");
  const o = await r.transporter.request({
    url: "/customer/update",
    data: n,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateCustomerInfo"
  );
}, Pt = (r) => async (n) => {
  const o = await r.transporter.request({
    url: "/email",
    data: { newEmail: P(n) },
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateCustomerEmail"
  );
}, Nt = t.object({
  newPassword: t.string(),
  i: t.string(),
  id: t.string()
}), Tt = (r) => async (n) => {
  m(Nt, n, "resetPassword");
  const o = await r.transporter.request({
    url: "/password-reset",
    data: n,
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "resetPassword"
  );
}, At = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: "/password-reset-email",
    data: {
      email: n,
      linkUri: o
    },
    method: i.POST
  });
  return a(
    s,
    p,
    l,
    "sendResetPasswordEmail"
  );
}, wt = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: "/password",
    data: {
      password: n,
      newPassword: o
    },
    method: i.PUT
  });
  return a(
    s,
    p,
    l,
    "updatePassword"
  );
}, I = t.object({
  items: t.array(
    t.object({
      createdAt: t.string(),
      product: t.number(),
      wishlistItem: t.number()
    })
  ),
  token: t.string()
}), jt = "0", O = (r) => `/customer/wishlists/${r ?? jt}`, kt = (r) => async (n) => {
  const o = await r.transporter.request({
    url: O(n == null ? void 0 : n.wishlist),
    data: {
      limit: n == null ? void 0 : n.limit,
      page: n == null ? void 0 : n.page
    },
    method: i.POST
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, It = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `${O(n.wishlist)}/items/${n.item}`,
    method: i.POST
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, Ot = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `${O(n.wishlist)}/items/${n.item}`,
    method: i.DELETE
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, Mt = (r) => async () => {
  const n = await r.transporter.request({
    url: "/customer",
    method: i.GET
  });
  return a(
    n,
    k,
    l,
    "getCustomerData"
  );
}, Ct = (r) => async () => {
  const n = await r.transporter.request({
    url: "/selection",
    method: i.GET
  });
  return a(
    n,
    p,
    l,
    "getSelection"
  );
}, D = t.object({
  email: t.string().optional(),
  firstName: t.string().optional(),
  lastName: t.string().optional(),
  company: t.string().optional(),
  address1: t.string().optional(),
  address2: t.string().nullable().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  country: t.string(),
  phoneNumber: t.string().optional(),
  state: t.string().optional(),
  vatNumber: t.string().optional()
}), W = t.object({
  paymentFailedPage: t.string().optional(),
  paymentReturnPage: t.string().optional(),
  ipAddress: t.string().optional(),
  address: D.optional(),
  shippingAddress: D.optional(),
  termsAndConditions: t.boolean().optional(),
  paymentMethod: t.string().optional(),
  shippingMethod: t.string().optional(),
  // paymentInitiateOnly: Used for payment buttons, only initiate payment without selecting the payment method as current method.
  // It will still go through stock check, but it will not flip the current payment method of the selection.
  // Will allow plugins that supports the option to be initiated without providing address information.
  paymentInitiateOnly: t.boolean().optional(),
  clientDetails: t.object({
    browserLang: t.string().optional(),
    userAgent: t.string().optional(),
    ip: t.string().optional()
  }).optional(),
  consents: j.optional(),
  paymentMethodSpecificFields: t.unknown().optional(),
  additionalNotes: t.string().optional(),
  additionalFields: t.record(t.string(), t.unknown()).optional()
}), Dt = t.object({
  action: t.literal("form"),
  formHtml: t.string(),
  formType: t.enum([
    "adyen-drop-in",
    "qliro",
    "stripe-payment-intents",
    "paypal_commerce"
  ]).optional(),
  formFields: t.record(t.string(), t.unknown()).optional(),
  token: t.string()
}), qt = t.object({
  action: t.literal("javascript"),
  formFields: t.record(t.string(), t.unknown()).optional(),
  code: t.string(),
  token: t.string()
}), xt = t.object({
  action: t.literal("redirect"),
  url: t.string(),
  token: t.string()
}), Et = t.object({
  action: t.literal("success"),
  token: t.string()
}), Rt = t.discriminatedUnion("action", [
  qt,
  xt,
  Dt,
  Et
]), vt = g.extend({
  errors: t.object({
    stock: t.enum(["unavailable_items"]).optional()
  }).passthrough(),
  unavailableItems: t.array(
    t.object({
      available: t.number().describe("The available quantity of the item"),
      unavailable: t.number().describe(
        "The quantity of the item that isn't available for the cart item"
      ),
      item: t.string().describe("The Centra item number"),
      originalQuantity: t.number().describe(
        "The quantity of the item as it was before POST /payment"
      ),
      product: b
    })
  ).optional()
}), Bt = g.extend({
  errors: t.object({
    paymentMethod: t.enum(["failed"]).optional()
  }).passthrough()
}), Ut = t.union([
  vt,
  Bt,
  t.object({
    selection: B.optional(),
    languages: t.array(h).optional(),
    paymentMethods: t.array(U).optional(),
    paymentFields: F.optional(),
    shippingMethods: t.array($).optional(),
    countries: t.array(y).optional(),
    loggedIn: k.optional(),
    location: S.optional()
  })
]), Ft = (r) => async (n) => {
  m(W, n, "postPayment");
  const o = await r.transporter.request({
    url: "/payment",
    data: n || {},
    method: i.POST
  });
  return a(
    o,
    Rt,
    Ut,
    "postPayment"
  );
}, $t = t.object({
  order: z,
  location: S,
  languages: t.array(h),
  countries: t.array(y),
  token: t.string()
}), zt = t.object({
  errors: t.object({
    selection: t.literal("not found").optional(),
    paymentMethod: t.literal("failed").optional()
  })
}), Wt = t.union([
  zt,
  l
]), Ht = (r) => async (n) => {
  m(W, n, "paymentResult");
  const o = await r.transporter.request({
    url: "/payment-result",
    data: n || {},
    method: i.POST
  });
  return a(
    o,
    $t,
    Wt,
    "paymentResult"
  );
}, Lt = t.object({
  address: f.partial().optional(),
  shippingAddress: f.partial().optional(),
  language: t.string().optional(),
  paymentReturnPage: t.string().optional(),
  paymentFailedPage: t.string().optional(),
  additionalFields: t.record(t.string(), t.unknown()).optional(),
  additionalNotes: t.string().optional(),
  cartAbandonmentEmail: t.boolean().optional()
}), _t = (r) => async (n) => {
  m(
    Lt,
    n,
    "paymentFieldsUpdate"
  );
  const o = await r.transporter.request({
    url: "/payment-fields",
    data: n || {},
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "paymentFieldsUpdate"
  );
}, Vt = t.object({
  shipTo: t.object({
    country: t.string().optional(),
    state: t.string().optional()
  }).optional(),
  language: t.string().optional()
}), Qt = (r) => async (n, o, s) => {
  const u = P(n);
  m(
    Vt,
    s,
    "subscribeToBackInStock"
  );
  const d = await r.transporter.request({
    url: "/back-in-stock-subscription",
    data: {
      email: u,
      item: o,
      ...s
    },
    method: i.POST
  });
  return a(
    d,
    g,
    l,
    "subscribeToBackInStock"
  );
}, Gt = t.object({
  subscribed: t.boolean(),
  token: t.string()
});
var H = /* @__PURE__ */ ((r) => (r.male = "male", r.female = "female", r))(H || {});
const Kt = t.object({
  country: t.string().optional(),
  language: t.string().optional(),
  gender: t.nativeEnum(H).optional()
}).optional(), Jt = (r) => async (n, o) => {
  const s = P(n);
  m(
    Kt,
    o,
    "subscribeToNewsletter"
  );
  const u = await r.transporter.request({
    url: `newsletter-subscription/${s}`,
    data: o || {},
    method: i.POST
  });
  return a(
    u,
    Gt,
    l,
    "paymentFieldsUpdate"
  );
}, Xt = t.object({
  itemId: t.string(),
  quantity: t.number().optional(),
  productUrl: t.string().optional()
}), Yt = (r) => async (n) => {
  m(Xt, n, "postItem");
  const o = await r.transporter.request({
    url: `/items/${n.itemId}/quantity/${n.quantity}`,
    data: {
      productUrl: n.productUrl
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postItem"
  );
}, L = t.object({
  lineId: t.string(),
  quantity: t.number().optional()
}), Zt = (r) => async (n) => {
  m(L, n, "deleteItem");
  const o = await r.transporter.request({
    url: `/lines/${n.lineId}/quantity/${n.quantity}`,
    method: i.DELETE
  });
  return a(
    o,
    p,
    l,
    "deleteItem"
  );
}, te = t.object({
  categories: t.array(t.string()).optional(),
  search: t.string().optional(),
  onlyAvailable: t.boolean().optional(),
  showAsNew: t.boolean().optional(),
  showAsOnSale: t.boolean().optional(),
  products: t.array(t.string()).optional(),
  skipFirst: t.number().int().default(0).optional(),
  limit: t.number().int().default(20).optional(),
  sortOrder: t.array(
    t.object({
      field: t.enum([
        "uri",
        "categoryItemSort",
        "collectionUri",
        "priceAsNumber",
        "createdAt",
        "modifiedAt"
      ]),
      order: t.enum(["asc", "desc"]).optional()
    })
  ).optional()
}).passthrough(), ee = t.array(
  t.object({
    data: t.union([
      t.string(),
      t.object({
        // "brands" field contains this field for filtering by the internal brand ID
        brand: t.string().optional(),
        // "categories" field contains this field for filtering by the internal category ID
        category: t.string().optional(),
        metaDescription: t.string().optional(),
        metaKeywords: t.string().optional(),
        metaTitle: t.string().optional(),
        hex: t.string().optional(),
        desc: t.string().optional(),
        name: t.union([t.string(), t.string().array()]).optional(),
        uri: t.string().optional()
      }).passthrough()
    ]).optional(),
    value: t.string().optional().describe("The value that should be used for the filter search"),
    count: t.number().optional().describe(
      "Items matching this filter option, combined with all filter methods applied"
    ),
    filterCount: t.number().optional().describe(
      "Items matching this filter option, with all other filter methods included except the filter method it belongs to"
    ),
    totalCount: t.number().optional().describe(
      "Items matching this filter option, with all filter methods excluded"
    )
  })
), ne = t.object({
  field: t.string().optional().describe("Name for this filter method"),
  values: ee
}), re = g.extend({
  products: t.array(b),
  productCount: t.number(),
  filter: t.array(ne)
}), oe = (r) => async (n) => {
  m(te, n, "getProducts");
  const o = await r.transporter.request({
    url: "products",
    data: n,
    method: i.POST
  });
  return a(
    o,
    re,
    l,
    "getProducts"
  );
};
function se(r, n) {
  return n && Object.keys(n).forEach((o) => {
    r[o] = n[o](r);
  }), r;
}
const ie = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `/shipping-methods/${n.shippingMethod}`,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "addWishlistItem"
  );
}, ae = (r) => async (n, o) => {
  const s = o ? `/countries/${n}/states/${o}` : `/countries/${n}`, u = await r.transporter.request({
    url: s,
    method: i.PUT
  });
  return a(
    u,
    p,
    l,
    "setCountry"
  );
}, ce = g.extend({
  countries: t.array(y)
}), le = (r) => async () => {
  const n = await r.transporter.request({
    url: "/countries",
    method: i.GET
  });
  return a(
    n,
    ce,
    l,
    "getCountries"
  );
}, ue = (r) => async (n) => {
  m(L, n, "updateItem");
  const o = await r.transporter.request({
    url: `/lines/${n.lineId}/quantity/${n.quantity}`,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateItem"
  );
}, pe = t.object({
  quantity: t.number(),
  section: t.number(),
  products: t.array(t.number())
}), me = t.object({
  priceType: t.string(),
  type: t.string(),
  bundle: t.number(),
  sections: t.array(pe),
  priceOfItems: t.string(),
  priceMin: t.string(),
  priceMax: t.string(),
  priceOfItemsAsNumber: t.number(),
  priceMinAsNumber: t.number(),
  priceMaxAsNumber: t.number(),
  priceMinBeforeDiscountAsNumber: t.number(),
  priceMaxBeforeDiscountAsNumber: t.number(),
  priceMinBeforeDiscount: t.string(),
  priceMaxBeforeDiscount: t.string(),
  discount: t.number()
}), de = b.extend({
  bundleInfo: me
}), ge = g.extend({
  bundle: de,
  sectionProducts: t.array(b)
}), be = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `bundles/${n.id}`,
    data: {
      includeSectionProducts: !0
    },
    method: i.POST
  });
  return a(
    o,
    ge,
    l,
    "getBundle"
  );
}, he = t.object({
  item: t.string(),
  sections: t.array(
    t.object({
      section: t.number(),
      item: t.string()
    })
  )
}), ye = (r) => async (n) => {
  m(he, n, "postBundle");
  const o = await r.transporter.request({
    url: `/items/bundles/${n.item}`,
    data: {
      item: n.item,
      sections: n.sections
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postBundle"
  );
}, fe = t.array(
  t.object({
    item: t.string(),
    quantity: t.number().optional()
  })
), Se = (r) => async (n) => {
  m(fe, n, "postItems");
  const o = await r.transporter.request({
    url: "/items",
    method: i.PUT,
    data: { items: n }
  });
  return a(
    o,
    p,
    l,
    "postItems"
  );
}, Pe = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `/vouchers/${n}`,
    method: i.DELETE
  });
  return a(
    o,
    p,
    l,
    "postVouchers"
  );
}, Ne = (r) => async (n) => {
  const o = await r.transporter.request({
    url: "/vouchers",
    data: {
      voucher: n
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postVouchers"
  );
};
function Oe(r) {
  const n = {
    transporter: G(r),
    options: r
  };
  return {
    getTokenHandler: () => r.centraTokenHandler,
    ...se(n, {
      subscribeToNewsletter: Jt,
      subscribeToBackInStock: Qt,
      register: dt,
      login: gt,
      logout: yt,
      getCustomerOrders: ht,
      getCustomerData: Mt,
      updateCustomerInfo: St,
      updateCustomerEmail: Pt,
      resetPassword: Tt,
      sendResetPasswordEmail: At,
      updatePassword: wt,
      getCustomerWishlistItems: kt,
      addWishlistItem: It,
      deleteWishlistItem: Ot,
      getSelection: Ct,
      postPayment: Ft,
      setShippingMethod: ie,
      paymentResult: Ht,
      paymentFieldsUpdate: _t,
      postItem: Yt,
      deleteItem: Zt,
      updateItem: ue,
      getProducts: oe,
      setCountry: ae,
      getCountries: le,
      getBundle: be,
      postBundle: ye,
      postItems: Se,
      deleteVouchers: Pe,
      postVouchers: Ne
    })
  };
}
const Te = 3600 * 24 * 7, Ae = "centra-api-token";
class Me {
  constructor(n = Te, o = Ae) {
    this.ttl = n, this.tokenName = o;
  }
  getToken() {
    return A.getWithExpiry(this.tokenName);
  }
  setToken(n) {
    A.setWithExpiry(this.tokenName, n, this.ttl);
  }
  removeToken() {
    A.remove(this.tokenName);
  }
}
const Ce = t.object({
  limit: t.number().optional(),
  page: t.number().optional(),
  wishlist: t.string().optional()
}), De = t.object({
  wishlist: t.string().optional(),
  item: t.string()
}), qe = t.object({
  paymentMethodFields: t.record(t.string(), t.unknown()).optional()
}), xe = t.object({
  shippingMethod: t.string()
});
function Ee(r) {
  var n, o, s, u, d, N;
  return (r == null ? void 0 : r.status) >= 400 && typeof ((o = (n = r == null ? void 0 : r.response) == null ? void 0 : n.data) == null ? void 0 : o.errors) == "object" && ((u = (s = r == null ? void 0 : r.response) == null ? void 0 : s.data) == null ? void 0 : u.errors) !== null && Object.keys((N = (d = r == null ? void 0 : r.response) == null ? void 0 : d.data) == null ? void 0 : N.errors).length > 0;
}
export {
  Me as CentraLocalStorageTokenHandler,
  i as Method,
  H as SubscribeToNewsletterGenderEnum,
  Q as Transport,
  It as addWishlistItem,
  f as addressSchema,
  st as bundleInfoModelSchema,
  nt as bundleInfoSchema,
  it as bundleModelSchema,
  X as categorySchema,
  de as centraCheckoutApiBundleProductSchema,
  x as centraCheckoutApiProductBaseSchema,
  et as centraCheckoutApiProductItemSchema,
  b as centraCheckoutApiProductSchema,
  ot as centraCheckoutApiRelatedProductSchema,
  ne as centraFilterResponse,
  ee as centraFilterValuesSchema,
  te as centraGetProductsPayloadSchema,
  Vt as centraSubscribeToBackInStockOptionsSchema,
  Kt as centraSubscribeToNewsletterOptionsSchema,
  j as consentSchema,
  y as countrySchema,
  Oe as createCentraCheckoutAPIClient,
  G as createTransporter,
  R as currencyModelSchema,
  V as defaultLogger,
  Zt as deleteItem,
  Ot as deleteWishlistItem,
  l as errorsResponseSchema,
  mt as errorsSchema,
  ge as getBundleResponseSchema,
  Mt as getCustomerData,
  ht as getCustomerOrders,
  kt as getCustomerWishlistItems,
  Ce as getCustomerWishlistOptionsSchema,
  oe as getProducts,
  re as getProductsResponseSchema,
  Ct as getSelection,
  Ee as isCentraErrorsResponse,
  at as itemBundleInfoSchema,
  h as languageSchema,
  S as locationSchema,
  q as loggedInBaseSchema,
  k as loggedInSchema,
  gt as login,
  yt as logout,
  Wt as orderCreatedErrorsResponseSchema,
  $t as orderCreatedResponseSchema,
  zt as orderCreatedSelectionNotFoundErrorSchema,
  C as orderResponseSchema,
  z as orderSchema,
  bt as ordersPagingSchema,
  c as paymentFieldModelSchema,
  F as paymentFieldsModelSchema,
  _t as paymentFieldsUpdate,
  Lt as paymentFieldsUpdateOptionsSchema,
  U as paymentMethodModelSchema,
  Bt as paymentResponseErrorPaymentMethodFailedSchema,
  Ut as paymentResponseErrorSchema,
  vt as paymentResponseErrorUnavailableItemsSchema,
  Dt as paymentResponseFormTypeSchema,
  qt as paymentResponseJavascriptTypeSchema,
  xt as paymentResponseRedirectTypeSchema,
  Rt as paymentResponseSuccessSchema,
  Et as paymentResponseSuccessTypeSchema,
  Ht as paymentResult,
  qe as paymentResultOptionsSchema,
  Yt as postItem,
  Ft as postPayment,
  D as postPaymentAddressSchema,
  W as postPaymentOptionsSchema,
  dt as register,
  J as registerOptionsSchema,
  Tt as resetPassword,
  Nt as resetPasswordOptionsSchema,
  pt as selectionAutoDiscountSchema,
  ct as selectionBundleModelSchema,
  E as selectionItemModelSchema,
  lt as selectionModelItemSchema,
  M as selectionModelPluginFieldsIngridSchema,
  ut as selectionModelPluginFieldsSchema,
  B as selectionModelSchema,
  p as selectionResponseSchema,
  v as selectionVoucherSchema,
  At as sendResetPasswordEmail,
  ie as setShippingMethod,
  xe as setShippingMethodOptionsSchema,
  $ as shippingMethodModelSchema,
  Qt as subscribeToBackInStock,
  Jt as subscribeToNewsletter,
  Gt as subscribedToNewsletterResponseSchema,
  rt as tableMappingSchema,
  g as tokenResponseSchema,
  Pt as updateCustomerEmail,
  St as updateCustomerInfo,
  ft as updateCustomerOptionsSchema,
  De as updateCustomerWishlistOptionsSchema,
  L as updateItemOptionsSchema,
  wt as updatePassword,
  O as wishlistBasePath,
  I as wishlistResponseSchema
};
